import { Component, ViewEncapsulation } from "@angular/core";

@Component({
   standalone: true,
   selector: "navbar",
   imports: [],
   template: `
      <div class="h-[6.5rem] bg-white shadow">
         <div class="mx-auto flex h-full w-[63%] items-center justify-center lg:justify-start gap-8 pb-4 pt-7 text-lg">
            <a href="https://marcusfoodco.com" class=""><img src="assets/img/mfc.svg" alt="MFC logo" class="w-[252px]" /></a>
            <div class="hidden lg:block lg:flex-grow"></div>
            <a href="mailto:info@marcusfoodco.com" class="hidden lg:inline no-underline text-right text-blue-800 hover:text-[#ebab21] duration-200">info@marcusfoodco.com</a>
            <a href="tel:1-316-686-7649" class="hidden lg:inline no-underline text-blue-800 mr-28 hover:text-[#ebab21] duration-200 whitespace-nowrap">(316) 686-7649</a>
         </div>
      </div>
   `,
   styles: [],
})
export class NavbarComponent {}
